export const widgetOptions = {
  SLIDER: 'slider',
  BEAUTIFUL_NUMBERS: 'beautiful_numbers',
  RED_BANNER: 'red_banner',
  APPLICATION_BANNER: 'application_banner',
  NEWS_SLIDER: 'news_slider',
  GRAY_BANNER: 'gray_banner',
  VOLTE_BANNER_NEW: 'volte_banner_simple',
  TARIFF_SLIDER: 'tariff_slider',
  GENERAL_SERVICE: 'general_service',
  IMPORTANT_STEP: 'important_step',
  FOR_FOREIGN_GUEST: 'for_foreign_guest',
  ACCORDION: 'accordion',
  HEADER: 'header',
  ROAMING_COUNTRY_SEARCH: 'roaming_country_search',
  HOTSPOT_MAP: 'hotspot_map',
  NEW_CAMPAIGN: 'new_campaign',
  TARIFF_DETAILS: 'tariff_details',
  FIND_OUR_OFFICE: 'find_our_office',
  HEADER_LINKS: 'header_links',
  TARIFF_FILTER: 'tariff_filter',
  ABOUT_ACTIVATION: 'about_activation',
  ADVANTAGEOUS_PRICE: 'advatageous_price',
  SERVICES: 'services',
  VERTICAL_TABLE: 'vertical_table',
  TARIFF_CHOICE: 'tariff_choice',
  OPERATION_LIST: 'operation_list',
  GENERAL_INFORMATION: 'general_information',
  VIDEO: 'video',
  SIMPLE_APPLICATION_BANNER: 'simple_application_banner',
  WHITE_CARDS: 'white_cards',
  VOLTE_BANNER: 'volte_banner',
  SUSTAINABILITY: 'sustainability',
  ADDRESS_CARDS: 'address_cards',
  PAYMENT_SYSTEMS: 'payment_systems',
  SMALL_CONTENT_BLOCK: 'small_content_block',
  GALLERY: 'gallery',
  HORIZONTAL_TABLE: 'horizontal_table',
  COLOR_CARD: 'color_card',
  CORPORATE_SOCIAL_RESPONSIBILITY: 'corporate_social_responsibility',
  VOLTE_DEVICE_SEARCH: 'volte_device_search',
  COMPANY_AWARD: 'company_award',
  COMPANY: 'company',
  KEY_MILESTONE: 'key_milestone',
  OPEN_POSITION: 'open_position',
  OUR_MANAGEMENT: 'our_management',
  BOARD_OF_DIRECTORS: 'board_of_directors',
  MEDIA_INQUIRE: 'media_inquire',
  PARTNERSHIP_REQUEST: 'partnership_request',
  TOPIC_GROUPS: 'topic_groups',
  LATEST_NEWS: 'latest_news',
  CHOOSE_TOPIC_SECTION: 'choose_topic_section',
  POST_WIDGET: 'post_widget',
  WHY_BAKCELL: 'why_bakcell',
  INFO_BOX: 'info_box',
  BUSINNES_CARD: 'businnes_card',
  INFO_BLOCK: 'info_block',
  FIND_YOUR_NUMBER: 'find_your_number',
  VIDEO_BLOG: 'video_blog',
  FIX_SERVICE: 'fix_service',
  TECHNICAL_SOLUTION: 'technical_solution',
  PRICING_TABLE: 'pricing_table',
  M2M_BUNDLES: 'm2m_bundles',
  TARIFF_SLIDER_BUSINESS: 'tariff_slider_business',
  BUSINESS_ADVANTAGEOUS_PRICE: 'business_advantageous_price',
  FIND_YOUR_NUMBER_ESIM: 'find_your_number_esim',
  INTERNET_ACTIVATION: 'internet_activation',
  ROAMING_ACTIVATION_BUSINESS: 'roaming_activation_business',
  ROAMING_COUNTRY_SEARCH_BUSINESS: 'roaming_country_search_business',
  ESIM_SWAP: 'esim_swap',
  TARIFF_SLIDER_BUSINESS_WITHOUT_HEADER:
    'tariff_slider_business_without_header',
  IMAGE_BANNER: 'image_banner',
  BLACK_BANNER: 'black_banner',
  TECHNICAL_BANNER: 'technical_banner',
  FIVE_G_BANNER: 'five_g_banner',
  FIVE_G_COVERAGE_AREA: 'five_g_coverage_area',
  FIVE_G_COLOR_CARDS: 'five_g_color_cards',
  WHO_WE_ARE: 'who_we_are',
  FULL_BANNER: 'full_banner',
  SEARCH_RESULT_WIDGET: 'searchResultWidget',
  FIBER_OFFERS: 'offers_widget',
  STEPS_WITH_IMAGE: 'steps_with_image',
  FIBER_ABOUT_US: 'fiberAboutUs',
  FIBER_TITELED_BANNER: 'fiberTiteledBanner',
  FIBER_PRODUCTS_SECTION: 'fiberProductSection',
  BACKDROP_TEXT_WIDGET: 'backdrop_text_widget',
  FIBER_DEVICE_WIDGET: 'fiber_device_widget',
  FIBER_INFO_BLOCK: 'fiber_info_block',
  CHECK_CONNECTION: 'check_connection',
  PRODUCT_HIGHLIGHT: 'product_highlight',
  PRODUCT_DETAIL: 'product_detail',
  RIGHT_IMAGE_BANNER: 'right_image_banner',
  PRODUCT_LIST: 'product_list',
  FIND_YOUR_NUMBER_SIM: 'find_your_number_sale',
  RESULT_BANNER: 'result_banner',
  ERROR_BANNER: 'error_banner',
  ESIM_BANNER: 'esim_banner',
};
